import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actCreateRouteFailed,
  actCreateRouteSuccess,
  MASTER_CREATE_ROUTE,
} from '../../actions/route'
import { apiCreateRoute } from '../../apis/route'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doCreate(action) {
  try {
    const response = yield call(apiCreateRoute, action?.payload)

    if (response?.statusCode === 200) {
      yield put(actCreateRouteSuccess({ data: response.data }))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
      addNotification(
        'route.notification.createSuccess',
        NOTIFICATION_TYPE.SUCCESS,
      )
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actCreateRouteFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchCreate() {
  yield takeLatest(MASTER_CREATE_ROUTE, doCreate)
}
